/**
 * ScrollToTop — global hygiene (PO 26-Aug): the app scrolls on the
 * DOCUMENT (no layout-level overflow container, verified by scout), so
 * the browser keeps the previous page's scroll offset across route
 * changes. Coming from the bottom of a long page onto a short one lands
 * the viewport below the content — the page looks blank (reported on
 * /api-keys, but it affects every short page).
 *
 * Mounted ONCE per layout, next to <Outlet/>: every route change snaps
 * the window to the top. PATHNAME only, on purpose — query/hash changes
 * (filters, tabs, in-page anchors) must NOT yank the user to the top.
 * Renders nothing; costs one effect per navigation.
 */
import { useEffect } from "react";
import { useLocation } from "react-router";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

